import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Foot, Layout } from 'sc-ui';

const propTypes = {};
const Footer = () => (
    <Layout.Vertical style={{ position: 'relative' }}>
        <svg
            id="svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 100"
            fill="none"
            style={{ position: 'absolute', top: 0, overflow: 'overlay' }}
        >
            <path d="M0,-25 C200,-75 300,-75 700,-25 Z" fill="#425a29bb" stroke="none" />
            <path
                d="M0,-50 C200,-25 300,-25 500,-50 S800,-75 1000,-50 L1000,0 L0,0 Z"
                fill="#425a29"
                stroke="#425a29"
                stroke-width="1"
                stroke-linecap="round"
            />
        </svg>
        <Foot>
            {/* <Foot.Column>
                <Foot.Title>What is this?</Foot.Title>
                <Foot.StyledLink to="/about">About</Foot.StyledLink>
            </Foot.Column> */}
            {/* <Foot.Column>
                <Foot.Title>Contact Us</Foot.Title>
                <Foot.Link>Link</Foot.Link>
            </Foot.Column> */}
            {/* <Foot.Column>
                <Foot.Title>Terms & Conditions</Foot.Title>
                <Foot.StyledLink to="/terms">Terms of Service</Foot.StyledLink>
            </Foot.Column> */}
            {/* <Foot.Column>
                <Foot.Title>Connect</Foot.Title>
                <Foot.Link href="https://www.facebook.com/smoothieclubvictoria/">
                    Facebook
                </Foot.Link>
                <Foot.Link href="https://www.instagram.com/smoothieclubvictoria/">
                    Instagram
                </Foot.Link>
                <Foot.Link href="https://wholeharmony.ca/">Whole Harmony</Foot.Link>
            </Foot.Column> */}
            <Foot.Column>
                <Foot.Title>Stay Healthy:</Foot.Title>
                <Foot.Link href="https://wholeharmony.ca/">Whole Harmony</Foot.Link>
                <Foot.Link href="https://www.facebook.com/wholeharmonynutrition/">
                    Facebook
                </Foot.Link>
                <Foot.Link href="https://www.instagram.com/whole.harmony.health/">
                    Instagram
                </Foot.Link>
            </Foot.Column>
        </Foot>
    </Layout.Vertical>
);
Footer.propTypes = propTypes;
export { Footer };



// WEBPACK FOOTER //
// ./src/_components/Footer.jsx